export default __webpack_public_path__ + "static/media/Gallery-6.3cd8a2c1.jpg";